import React from 'react'
import {Grid, Container, Box} from '@mui/material'
import Page from 'components/Page/Page'
import CurrentRate from 'components/Page/Dashboard/CurrentRate'
import DailyMeterReadings from 'components/Page/Dashboard/DailyMeterReadings'
import NumberReadings from 'components/Page/Dashboard/NumberReadings'
import InvoicesCostChart from 'components/Page/Dashboard/InvoicesCostChart'

const Dashboard = () => {
    return (
        <Page>
            <Container maxWidth="xxl">
                <Box sx={{py: 3}}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} md={6} xl={4}>
                            <CurrentRate />
                        </Grid>
                        <Grid item xs={12} md={6} xl={4}>
                            <NumberReadings />
                        </Grid>
                        <Grid item xs={12} md={6} xl={4}>
                            <InvoicesCostChart />
                        </Grid>
                        <Grid item xs={12} md={6} xl={12}>
                            <DailyMeterReadings />
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </Page>
    )
}

export default Dashboard
